document.querySelectorAll('a').forEach(function(link) {
    const href = link.getAttribute('href') || ''
    if (href.indexOf('mailto') !== -1) return
    if (link.hostname && link.hostname !== window.location.hostname) {
        link.setAttribute('target', '_blank')
        link.setAttribute('rel', 'nofollow')
    }
})
